import { TechemTheme } from '@techem/techem-theme';
import React from 'react';
import { paths } from '../../../../frameworks_drivers/routes';
import { useMediaQuery } from '../../../../tools/hooks/useMediaQuery';
import { TrackerUtil } from '../../../../tracking/TrackerUtil';
import { styled } from 'baseui';

const StyledSpan = styled('span', {
  color: TechemTheme.colors.buttonPrimaryFill,
  userSelect: 'none',
  cursor: 'pointer',
  ':focus': {
    textDecoration: 'underline',
    color: TechemTheme.colors.buttonPrimaryFill
  }
});

interface Props {
  handleOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  text: string;
}

const DataProtectionClickableLink: React.FC<Props> = ({ handleOpenModal, text }) => {
  const isMobile = useMediaQuery('(max-width: 576px)');

  const handleOpenWindow = () => {
    window.open(`/onboarding#${paths.DataProtection}`, '_blank');
  };

  return (
    <StyledSpan
      tabIndex={0}
      onClick={() => {
        TrackerUtil.trackLinkClick(
          'email-data_inline-link_data-privacy',
          'inline-link_data-privacy'
        );
        isMobile ? handleOpenModal(true) : handleOpenWindow();
      }}
      dangerouslySetInnerHTML={{ __html: text }}
      data-gi="data-protection"
    />
  );
};

export { DataProtectionClickableLink };
